/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ObservabilityTraceQueryRequest,
  ObservabilityTraceQueryResponse
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPostApiObservabilityTraceQueryUrl = () => {




  return `/api/observability/trace/query`
}

export const postApiObservabilityTraceQuery = async (observabilityTraceQueryRequest: ObservabilityTraceQueryRequest, options?: RequestInit): Promise<ObservabilityTraceQueryResponse> => {

  return orvalControlFetch<ObservabilityTraceQueryResponse>(getPostApiObservabilityTraceQueryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      observabilityTraceQueryRequest,)
  }
);}




export const getPostApiObservabilityTraceQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiObservabilityTraceQuery>>, TError,{data: ObservabilityTraceQueryRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiObservabilityTraceQuery>>, TError,{data: ObservabilityTraceQueryRequest}, TContext> => {

const mutationKey = ['postApiObservabilityTraceQuery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiObservabilityTraceQuery>>, {data: ObservabilityTraceQueryRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiObservabilityTraceQuery(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiObservabilityTraceQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postApiObservabilityTraceQuery>>>
    export type PostApiObservabilityTraceQueryMutationBody = ObservabilityTraceQueryRequest
    export type PostApiObservabilityTraceQueryMutationError = unknown

    export const usePostApiObservabilityTraceQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiObservabilityTraceQuery>>, TError,{data: ObservabilityTraceQueryRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiObservabilityTraceQuery>>,
        TError,
        {data: ObservabilityTraceQueryRequest},
        TContext
      > => {
      return useMutation(getPostApiObservabilityTraceQueryMutationOptions(options), queryClient);
    }
